import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
  interactive?: boolean;
  children: ReactNode;
}

export function Card({
  padded = true,
  interactive = false,
  className,
  children,
  ...rest
}: CardProps) {
  const classes = [
    styles.card,
    padded ? styles.padded : undefined,
    interactive ? styles.interactive : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  icon?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
}

export function CardHeader({ icon, title, actions }: CardHeaderProps) {
  return (
    <div className={styles.header}>
      {icon != null && (
        <span className={styles.headerIcon} aria-hidden>
          {icon}
        </span>
      )}
      <h3 className={styles.headerTitle}>{title}</h3>
      {actions != null && <div style={{ marginLeft: 'auto' }}>{actions}</div>}
    </div>
  );
}
